import { BaseServices, HttpMethod } from '@services/base'

import { BridgeService } from './bridge'

export interface ParameterResponse {
  id: number
  name: string
  description: string
  value: string
  active: boolean
  createdAt: string
  updatedAt: string
  modifiedBy: string
}

export default (accessToken?: string) => {
  const pathname = accessToken
    ? process.env.REACT_APP_GET_USE_NEW_PROVIDERS_WEB
    : process.env.REACT_APP_GET_USE_NEW_PROVIDERS_APP

  const method = HttpMethod.GET
  const host = process.env.REACT_APP_API_HOST
  const headers: Record<string, string> = {}

  if (BridgeService.isBrowser() && accessToken) {
    headers.Authorization = `Bearer ${accessToken}`
  }

  return BaseServices.request<ParameterResponse>({
    headers,
    pathname,
    method,
    host,
  })
}
